import { Box, BoxProps, IconButton, Stack, styled, useTheme } from '@mui/material';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { FaIcon } from '../icons';
import { JSXChildren } from '../../../libs/types';
import { Divider } from './divider';
import { DelayedLinearProgress } from '../../molecules/feedback';

export type ClosableDrawerProps = DrawerProps & {
  controls?: JSXChildren;
  loading?: boolean;
  onXCloseClick?: () => void;
  disableControlsDivider?: boolean;
  paneProps?: BoxProps;
};

export function ClosableDrawer({
  sx,
  controls,
  loading = false,
  onXCloseClick,
  disableControlsDivider = false,
  paneProps,
  ...props
}: ClosableDrawerProps) {
  const theme = useTheme();

  const handleCrossClick = () => {
    typeof onXCloseClick === 'function' ? onXCloseClick() : props.onClose && props?.onClose({}, 'backdropClick');
  };

  return (
    <Drawer anchor="right" {...props}>
      <DelayedLinearProgress show={loading} />
      <DrawerContainer>
        <DrawerHeaderContainer>
          <IconButton
            onClick={handleCrossClick}
            sx={{ marginTop: theme.spacing(1), width: theme.spacing(1.8), height: theme.spacing(1.8) }}
          >
            <FaIcon name={'xmark-large'} width={theme.spacing(1.7)} height={theme.spacing(1.7)} />
          </IconButton>
        </DrawerHeaderContainer>
        <DrawerPane {...paneProps}>{props.children}</DrawerPane>
        {controls && (
          <DrawerControlsContainer>
            {!disableControlsDivider && <Divider />}
            {controls}
          </DrawerControlsContainer>
        )}
      </DrawerContainer>
    </Drawer>
  );
}

const DrawerContainer = styled(Stack)(({ theme }) => ({
  height: '100%',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

const DrawerHeaderContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const DrawerPane = styled(Box)(({ theme }) => ({
  maxHeight: `calc(100% - ${theme.spacing(4)})`,
  height: `calc(100% - ${theme.spacing(4)})`,
  overflow: 'auto',
}));

const DrawerControlsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1),
}));
